/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：428__part-16
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_11 from /* 11 */"../../11"
import * as /* [auto-meaningful-name] */Module_25 from /* 25 */"../../25/index"
import * as /* [auto-meaningful-name] */Module_10 from /* 10 */"../../10/index"
import * as /* [auto-meaningful-name] */Module_14 from /* 14 */"../../14"
import /* [auto-meaningful-name] */Axios from /* 129 */"axios"
import * as /* [auto-meaningful-name] */Module_7 from /* 7 */"../../7"
import /* [auto-meaningful-name] */RegeneratorRuntime from /* 1 */"regenerator-runtime"
import * as /* [auto-meaningful-name] */Module_87 from /* 87 */"../../48/87"
import * as /* [auto-meaningful-name] */Module_27 from /* 27 */"../../27"
import * as /* [auto-meaningful-name] */Module_39 from /* 39 */"../../39"
import * as /* [auto-meaningful-name] */Socket_ioClient from /* 485 */"socket.io-client"
import /* [auto-meaningful-name] */Socket_ioClient1 from /* 485 */"socket.io-client"
import * as /* [auto-meaningful-name] */Module_20 from /* 20 */"../index"
import * as /* [auto-meaningful-name] */Src_shared_env from /* 57 */"../../../../../../src/shared/env"
var Bl = "".concat(Src_shared_env.a.socketHost, ":9090")
var Fl = function () {
  function e(t, n, r) {
    var o = this
    Module_27.a(this, e)
    this.workId = t
    this.roomName = n
    this.roomId = r
    this.members = []
    this.username = undefined
    this.socket = undefined
    this.error = function (e) {
      if (e.message) {
        Module_20.emitRoomError(e.message)
      } else {
        Module_20.emitRoomError("网络异常")
      }
    }
    this.onMemberJoin = function (e) {
      if (!o.members.includes(e.username)) {
        o.members.push(e.username)
      }
      Module_20.emitRoomMemberJoin(e.username)
    }
    this.onMemberLeave = function (e) {
      var t = o.members.indexOf(e.username)
      if (-1 !== t) {
        o.members.splice(t, 1)
      }
      Module_20.emitRoomMemberLeave(e.username)
    }
    this.onReceiveData = function (e) {
      Object.entries(e.data).forEach(function (e) {
        var t = Module_10.a(e, 2)
        var n = t[0]
        var r = t[1]
        Module_20.emitRoomMessage(n, r)
      })
    }
  }
  Module_39.a(e, [
    {
      key: "join",
      value: function () {
        var e = Module_7.a(RegeneratorRuntime.mark(function e(t) {
          var n = this
          return RegeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  e.next = 2
                  return Module_87.b(this.roomId)
                case 2:
                  if (e.sent) {
                    e.next = 5
                    break
                  }
                  throw new Error("Cannot join room")
                case 5:
                  this.username = t
                  return e.abrupt("return", new Promise(function (e, r) {
                    var o = Socket_ioClient1(Bl, {
                      path: "/coconut",
                      query: Module_87.a(),
                      transports: ["websocket"]
                    })
                    window.socket = o
                    o.once("error", n.error)
                    o.once("disconnect", n.error)
                    o.once("connect", function () {
                      o.emit("join", {
                        work_id: n.workId,
                        room_name: n.roomName,
                        username: t,
                        room_id: n.roomId
                      })
                      o.once("join_ack", function (t) {
                        n.socket = o
                        n.subscribe()
                        e(t)
                      })
                      o.off("disconnect", n.error)
                      o.off("error", n.error)
                    })
                  }))
                case 7:
                case "end":
                  return e.stop()
              }
            }
          }, e, this)
        }))
        return function (t) {
          return e.apply(this, arguments)
        }
      }()
    }, {
      key: "subscribe",
      value: function () {
        var /* [auto-meaningful-name] */this$socket
        var /* [auto-meaningful-name] */this$socket1
        var /* [auto-meaningful-name] */this$socket2
        var /* [auto-meaningful-name] */this$socket3
        if (!(null === (this$socket = this.socket) || undefined === this$socket)) {
          this$socket.on("join", this.onMemberJoin)
        }
        if (!(null === (this$socket1 = this.socket) || undefined === this$socket1)) {
          this$socket1.on("leave", this.onMemberLeave)
        }
        if (!(null === (this$socket2 = this.socket) || undefined === this$socket2)) {
          this$socket2.on("broadcast", this.onReceiveData)
        }
        if (!(null === (this$socket3 = this.socket) || undefined === this$socket3)) {
          this$socket3.on("error", this.error)
        }
      }
    }, {
      key: "unsubscribe",
      value: function () {
        var /* [auto-meaningful-name] */this$socket
        var /* [auto-meaningful-name] */this$socket1
        var /* [auto-meaningful-name] */this$socket2
        var /* [auto-meaningful-name] */this$socket3
        if (!(null === (this$socket = this.socket) || undefined === this$socket)) {
          this$socket.off("join", this.onMemberJoin)
        }
        if (!(null === (this$socket1 = this.socket) || undefined === this$socket1)) {
          this$socket1.off("leave", this.onMemberLeave)
        }
        if (!(null === (this$socket2 = this.socket) || undefined === this$socket2)) {
          this$socket2.off("broadcast", this.onReceiveData)
        }
        if (!(null === (this$socket3 = this.socket) || undefined === this$socket3)) {
          this$socket3.off("error", this.error)
        }
      }
    }, {
      key: "leave",
      value: function () {
        var /* [auto-meaningful-name] */this$socket
        var /* [auto-meaningful-name] */this$socket1
        this.unsubscribe()
        if (!(null === (this$socket = this.socket) || undefined === this$socket)) {
          this$socket.emit("leave", {
            work_id: this.workId,
            room_name: this.roomName,
            room_id: this.roomId,
            username: this.username
          })
        }
        if (!(null === (this$socket1 = this.socket) || undefined === this$socket1)) {
          this$socket1.close()
        }
      }
    }, {
      key: "broadcast",
      value: function () {
        var e = Module_7.a(RegeneratorRuntime.mark(function e(t) {
          var /* [auto-meaningful-name] */this$socket
          return RegeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!(null === (this$socket = this.socket) || undefined === this$socket)) {
                    this$socket.emit("broadcast", {
                      username: this.username,
                      room_id: this.roomId,
                      data: t
                    })
                  }
                case 1:
                case "end":
                  return e.stop()
              }
            }
          }, e, this)
        }))
        return function (t) {
          return e.apply(this, arguments)
        }
      }()
    }, {
      key: "updateMemberList",
      value: function () {
        var e = Module_7.a(RegeneratorRuntime.mark(function e() {
          var /* [auto-meaningful-name] */e$sent
          return RegeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  e.next = 2
                  return Module_87.f(this.roomId)
                case 2:
                  e$sent = e.sent
                  this.members = e$sent || []
                case 4:
                case "end":
                  return e.stop()
              }
            }
          }, e, this)
        }))
        return function () {
          return e.apply(this, arguments)
        }
      }()
    }
  ])
  return e
}()
var Gl = {}
function Wl(e, t, n) {
  return e.then(function (e) {
    if (t) {
      return Promise.resolve(t.apply(undefined, Module_25.a(e)))
    }
  }).catch(function (e) {
    var /* [auto-meaningful-name] */e$response
    var /* [auto-meaningful-name] */e$response$data
    var /* [auto-meaningful-name] */e$message = e.message
    if (Axios.isAxiosError(e)) {
      if ("ECONNABORTED" === e.code) {
        e$message = "网络有问题"
      } else {
        if (null === (e$response = e.response) || undefined === e$response || null === (e$response$data = e$response.data) || undefined === e$response$data ? undefined : e$response$data.msg) {
          e$message = e.response.data.msg
        }
      }
    }
    if (n) {
      Module_14.a.condition(false, {
        type: "error",
        message: "房间积木：".concat(e$message)
      })
      return Promise.resolve(n(e$message))
    }
  })
}
function Ul(e) {
  Gl.workId = e.workId
  Module_87.g(e.context)
}
function Hl(e, t, n) {
  return Wl(Module_87.d(e).then(function () {
    Gl.username = e
    return [e]
  }), t, n)
}
function Vl(e, t, n, r) {
  return zl.apply(this, arguments)
}
function zl() {
  return (zl = Module_7.a(RegeneratorRuntime.mark(function e(t, n, r, o) {
    var /* [auto-meaningful-name] */Gl$workId
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            Gl$workId = Gl.workId
            Module_14.a.isNumber(n, {
              type: "error",
              messageId: "argNotNumber",
              values: {
                name: "房间人数"
              }
            })
            return e.abrupt("return", Wl(Module_7.a(RegeneratorRuntime.mark(function e() {
              return RegeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (undefined !== Gl$workId) {
                        e.next = 2
                        break
                      }
                      return e.abrupt("return", o("not initialized"))
                    case 2:
                      e.next = 4
                      return Module_87.c(t, Gl$workId, n).then(function (e) {
                        if (!e) {
                          o("创建房间失败")
                        }
                      })
                    case 4:
                      return e.abrupt("return", [t, n])
                    case 5:
                    case "end":
                      return e.stop()
                  }
                }
              }, e)
            }))(), r, o))
          case 3:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function Yl(e, t) {
  return Kl.apply(this, arguments)
}
function Kl() {
  return (Kl = Module_7.a(RegeneratorRuntime.mark(function e(t, n) {
    var /* [auto-meaningful-name] */Gl$workId
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            Gl$workId = Gl.workId
            return e.abrupt("return", Wl(Module_7.a(RegeneratorRuntime.mark(function e() {
              var t
              var n
              return RegeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (undefined !== Gl$workId) {
                        e.next = 2
                        break
                      }
                      throw new Error("not initialized")
                    case 2:
                      t = []
                      n = []
                      e.next = 6
                      return Module_87.e(Gl$workId).then(function (e) {
                        if (e) {
                          e.forEach(function (e) {
                            t.push(e.room_name)
                            n.push(e.username_list)
                          })
                        }
                        Gl.roomList = e
                      })
                    case 6:
                      return e.abrupt("return", [t, n])
                    case 7:
                    case "end":
                      return e.stop()
                  }
                }
              }, e)
            }))(), t, n))
          case 2:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function ql(e, t, n) {
  return Xl.apply(this, arguments)
}
function Xl() {
  return (Xl = Module_7.a(RegeneratorRuntime.mark(function e(t, n, r) {
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", Wl(Module_7.a(RegeneratorRuntime.mark(function e() {
              var /* [auto-meaningful-name] */Gl$workId
              var /* [auto-meaningful-name] */Gl$username
              var o
              var /* [auto-meaningful-name] */e$sent
              var a
              var /* [auto-meaningful-name] */e$sent1
              return RegeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (Gl$workId = Gl.workId, Gl$username = Gl.username, !Gl$workId) {
                        e.next = 7
                        break
                      }
                      e.next = 4
                      return Module_87.e(Gl$workId)
                    case 4:
                      e$sent = e.sent
                      a = e$sent.find(function (e) {
                        return e.room_name === t
                      })
                      o = null === a || undefined === a ? undefined : a.id
                    case 7:
                      if (Gl.roomName = t, undefined !== Gl$workId && undefined !== o) {
                        e.next = 11
                        break
                      }
                      console.error("进入房间失败")
                      throw new Error("进入房间失败")
                    case 11:
                      if (undefined !== Gl$username) {
                        e.next = 14
                        break
                      }
                      console.error("未设置昵称")
                      throw new Error("未设置昵称")
                    case 14:
                      if (Gl.session) {
                        Gl.session.leave()
                      }
                      Gl.session = new Fl(Gl$workId, t, o)
                      e.next = 18
                      return Gl.session.join(Gl$username)
                    case 18:
                      e$sent1 = e.sent
                      Gl.session.members = e$sent1.username_list
                      return e.abrupt("return", [t, Gl.session.members.length])
                    case 21:
                    case "end":
                      return e.stop()
                  }
                }
              }, e)
            }))(), n, r))
          case 1:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function Ql() {
  return Zl.apply(this, arguments)
}
function Zl() {
  return (Zl = Module_7.a(RegeneratorRuntime.mark(function e() {
    var /* [auto-meaningful-name] */Gl$session
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (!(null === (Gl$session = Gl.session) || undefined === Gl$session)) {
              Gl$session.leave()
            }
            Gl.session = undefined
          case 2:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function Jl(e, t, n) {
  return $l.apply(this, arguments)
}
function $l() {
  return ($l = Module_7.a(RegeneratorRuntime.mark(function e(t, n, r) {
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", Wl(Module_7.a(RegeneratorRuntime.mark(function e() {
              return RegeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (Gl.session) {
                        e.next = 2
                        break
                      }
                      throw new Error("no session")
                    case 2:
                      if (n) {
                        e.next = 4
                        break
                      }
                      return e.abrupt("return", [])
                    case 4:
                      Gl.session.broadcast(Module_11.a({}, t, n))
                      return e.abrupt("return", [])
                    case 6:
                    case "end":
                      return e.stop()
                  }
                }
              }, e)
            }))(), undefined, r))
          case 1:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function eu(e, t, n) {
  return tu.apply(this, arguments)
}
function tu() {
  return (tu = Module_7.a(RegeneratorRuntime.mark(function e(t, n, r) {
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", Wl(Module_7.a(RegeneratorRuntime.mark(function e() {
              var /* [auto-meaningful-name] */Gl$session
              return RegeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (Gl$session = Gl.session) {
                        e.next = 3
                        break
                      }
                      return e.abrupt("return", r("not connected"))
                    case 3:
                      e.next = 5
                      return Gl$session.updateMemberList()
                    case 5:
                      return e.abrupt("return", [Gl$session.members])
                    case 6:
                    case "end":
                      return e.stop()
                  }
                }
              }, e)
            }))(), n, r))
          case 1:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function nu() {
  return ru.apply(this, arguments)
}
function ru() {
  return (ru = Module_7.a(RegeneratorRuntime.mark(function e() {
    var /* [auto-meaningful-name] */Gl$session
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", null === (Gl$session = Gl.session) || undefined === Gl$session ? undefined : Gl$session.roomName)
          case 1:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
function ou() {
  return iu.apply(this, arguments)
}
function iu() {
  return (iu = Module_7.a(RegeneratorRuntime.mark(function e() {
    var /* [auto-meaningful-name] */Gl$session
    return RegeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", null === (Gl$session = Gl.session) || undefined === Gl$session ? undefined : Gl$session.members)
          case 1:
          case "end":
            return e.stop()
        }
      }
    }, e)
  }))).apply(this, arguments)
}
export { Ul }
export { Hl }
export { Vl }
export { Yl }
export { ql }
export { Ql }
export { Jl }
export { eu }
export { nu }
export { ou }
